<template>
  <button
    class="btn printer-calibration-button"
    :hidden="toggle.printerPlugin"
    @click="open()"
  >
    <md-tooltip>Calibrar impressora</md-tooltip>
    <md-icon md-src="/static/images/icon-printer-calibration.svg" />
  </button>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'PrinterCalibrationButton',
  props: {
    open: Function,
  },
  computed: {
    ...mapGetters(['toggle']),
  },
};
</script>

<style lang="scss">
@import '../../../../static/stylesheets/variables';

.printer-calibration-button {
  width: 44px;
  height: 44px;
  background-color: $brand-primary;
  border-radius: 100%;

  .md-icon {
    padding: 4px;
    width: 45px;
    height: 45px;
  }
}
</style>
